import { Component, Host, Prop, h, State, Listen, Method, Watch } from '@stencil/core';

@Component({
  tag: 'jump-filter',
  styleUrl: 'jump-filter.scss',
  shadow: true,
})
export class JumpFilter {

  @Prop() direction: 'horizontal' | 'vertical' = 'vertical';
  @Prop() filterHeading: string = 'Filtra per';
  @Prop() filterButtonLabel: string = 'Filtri';
  @Prop() filterButtonIcon: string = 'sliders';
  @Prop() mobileThreshold: number = 768;
  @Prop() filters: any;
  @Prop() showCount: boolean = false;
  @Prop() offCanvasOverlay: boolean = false;

  @State() activeFilters: number = 0;
  @State() showMobileFilters: boolean = false;
  @State() isMobile: boolean = false;
  @State() offCanvasClasses: string = 'filtersDrawer__overlay';

  mobileToggle: HTMLElement | null;
  filtersDrawer: HTMLElement;

  @Listen('jump-filterchange')
  filterChangeHandler(event: CustomEvent) {
    //set this.filter as this.filters[event.detail.name] = event.detail.value; even if not present
    this.filters = { ...this.filters, [event.detail.name]: event.detail.values };
    console.log('Received the custom filterChange event: ', this.filters);


    //TODO: increment this.activeFilters
  }

  @Listen('resize', { target: 'window' })
  handleResize() {
    this.isMobile = window.innerWidth < this.mobileThreshold;
  }

  @Watch('showMobileFilters')
  watchHandler(newValue: boolean, oldValue: boolean) {
    if (newValue !== oldValue) {
      if (newValue) {
        this.mobileToggle?.setAttribute('aria-expanded', 'true');
        this.filtersDrawer?.setAttribute('aria-hidden', 'false');
        this.offCanvasClasses = 'filtersDrawer__overlay filtersDrawer__overlay--active';
      } else {
        this.mobileToggle?.setAttribute('aria-expanded', 'false');
        this.filtersDrawer?.setAttribute('aria-hidden', 'true');
        this.offCanvasClasses = 'filtersDrawer__overlay';
      }
    }
  }

  /**
   * Get the active filters from the component
   */
  @Method()
  async getFilters() {
    return this.filters;
  }

  componentDidLoad() {
    this.handleResize();
  }

  render() {
    return (
      <Host mobileFilters={this.showMobileFilters}>
        {this.isMobile && <jump-button
          ref={(el) => {
            this.mobileToggle = el;
          }}
          buttonId={this.filterButtonIcon} variant={'primary'} outline
          onClick={() => this.showMobileFilters = !this.showMobileFilters}>
          <slot name="prefix">
            {this.filterButtonIcon &&
              <jump-icon library="fa" category="regular" name={this.filterButtonIcon} size="small"></jump-icon>}
            {this.filterButtonLabel}
          </slot>
          <slot name="suffix">
            {this.activeFilters > 0 &&
              <jump-badge label={this.activeFilters.toString()} variant="success" soft dimension="dot">1</jump-badge>}
          </slot>
        </jump-button>}

        {this.offCanvasOverlay &&
          <div class={this.offCanvasClasses}
               onClick={() => this.showMobileFilters = false}></div>}

        {<div
          ref={(el) => {
            this.filtersDrawer = el;
          }}
          class="filtersDrawer" data-variant={this.direction}>
          {!this.isMobile &&
            <div class={'filtersDrawer__header'}>
              <jump-icon class="small" name={this.filterButtonIcon}></jump-icon>
              <h3>{this.filterHeading}</h3>
            </div>}
          {this.isMobile && <jump-icon library="lucide" name="x" size="medium" label="" class={'filtersDrawer__close'}
                                       onClick={() => this.showMobileFilters = false}></jump-icon>}
          <slot></slot>
        </div>}
      </Host>
    );
  }
}
